import styled from "@emotion/styled";
import { Button, Form, Input, message, Popover, Select, Space, Table, Tag } from "antd";
import { t } from "i18next";
import { FC, useCallback, useEffect, useState } from "react";
import { ActivityEntity } from "../../../module/activity/entity/activity.entity";
import { ActivityParam } from "../../../module/activity/param/activity.param";
import activityService from "../../../module/activity/service/activity.service";
// import { PaginationEntity } from "../../../common/entity/pagination.entity";
import { useNavigate } from "react-router-dom";
import { checkPermission } from "src/module/admin/service/permission.service";
const { Option } = Select;

export const PackageActivityList: FC = () => {
	const navigate = useNavigate();
	const [searchObj, setSearchObj] = useState<ActivityParam>({ type: 6 });
	const [dataList, setDataList] = useState<ActivityEntity[]>([]);
	const [total, setTotal] = useState<number>(0);
	// const [paginationObj, setPaginationObj] = useState<PaginationEntity>({
	// 	customPageSize: 15,
	// 	customPageNum: 1,
	// });

	const onfinish = (value: any) => {
		setSearchObj({ ...searchObj, ...value,customPageSize: 15,
			customPageNum: 1, });
	};

	const init = useCallback(async () => {
		const { data } = await activityService.list({ ...searchObj});
		if (data.code === 200) {
			setDataList(data.data.list);
			setTotal(data.data.total);
		}
	}, [searchObj]);

	useEffect(() => {
		init();
	}, [init]);

	const changeStatus = async (id: number, status: number) => {
		const { data } = await activityService.changeStatus({ id, status });
		if (data.code === 200) {
			message.success(t("success"));
			init();
		} else {
			message.error(data.msg);
		}
	};
	const columns = [
		{
			title: t("activityId"),
			dataIndex: "id",
		},
		{ width: 180, title: t("activityName"), dataIndex: "title" },
		{
			title: t("price"),
			dataIndex: "money",
		},
		{
			title: t("limitedPurchaseTime"),
			dataIndex: "limitNum",
		},
		{
			title: t("issueQuantity"),
			dataIndex: "grantNum",
		},

		{
			title: t("InventoryQuantity"),
			dataIndex: "remainingNum",
		},
		{
			title: t("distributionAmount"),
			dataIndex: "promoteMoney",
		},
		{
			title: t("startTime"),
			dataIndex: "beginDate",
		},
		{
			title: t("endTime"),
			dataIndex: "endDate",
		},
		{
			width: 200,
			title: t("site.name"),
			dataIndex: "shopName",
			render: (text: string) => {
				return (
					<Popover content={text}>
						<Tag>{t("shopName")}</Tag>
					</Popover>
				);
			},
		},

		{
			title: t("sort"),
			dataIndex: "sort",
		},
		{
			title: t("status"),
			dataIndex: "status",
			render: (text: number) => {
				return text === 1 ? <Tag color='blue'>{t("onSale")}</Tag> : <Tag color='pink'>{t("off")}</Tag>;
			},
		},
		{
			title: t("action"),
			render: (record: any) => {
				return (
					<Space>
						{checkPermission(242) && record.status === 1 && (
							<Button
								type='primary'
								danger
								onClick={() => {
									changeStatus(record.id, 2);
								}}
							>
								{t("off")}
							</Button>
						)}
						{checkPermission(241) && record.status === 2 && (
							<Button
								type='primary'
								onClick={() => {
									changeStatus(record.id, 1);
								}}
							>
								{t("onSale")}
							</Button>
						)}
						{checkPermission(240) && (
							<Button
								type='primary'
								onClick={() => {
									navigate("/activity/package/" + record.id);
								}}
							>
								{t("edit")}
							</Button>
						)}
					</Space>
				);
			},
		},
	];

	return (
		<Container>
			<Form layout='inline' onFinish={onfinish}>
				<Form.Item label={t("activityName")} name='title'>
					<Input placeholder={t("activityName")} allowClear />
				</Form.Item>
				<Form.Item label={t("activityStatus")} name='status'>
					<Select placeholder={t("activityStatus")} allowClear>
						<Option value={1}>{t("onSale")}</Option>
						<Option value={2}>{t("off")}</Option>
					</Select>
				</Form.Item>
				<Form.Item>
					<Space>
						<Button type='primary' htmlType='submit'>
							{t("search")}
						</Button>
						{checkPermission(239) && (
							<Button
								type='primary'
								onClick={() => {
									navigate("/activity/package/add");
								}}
							>
								{t("addActivity")}
							</Button>
						)}
					</Space>
				</Form.Item>
			</Form>
			<Table
				columns={columns}
				dataSource={dataList}
				rowKey={(record) => record.id + ""}
				style={{ marginTop: 20 }}
				pagination={{
					pageSize: searchObj.customPageSize,
					current: searchObj.customPageNum,
					total: total,
					showTotal: () => {
						return (
							<div>
								{t("total")} {total}
							</div>
						);
					},
				}}
				onChange={(pagination) => {
					setSearchObj({
						...searchObj,
						customPageNum: pagination.current ?? 1,
						customPageSize: pagination.pageSize ?? 15,
					});
				}}
			/>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
	padding: 20px;
`;
